module.exports = __webpack_public_path__ + "static/media/login_logo_high_res.e06b5af6.png";